import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useTradicionalGroupsChartsDataContext } from './hooks/useTradicionalGroupsChartsDataContext';

export const IndigenousFamily = () => {
    const { chartData } = useTradicionalGroupsChartsDataContext();

    return (
        <Donut
            title={'Família Indígena'}
            subtitles={chartData?.indigenousFamily?.map(
                (item) => item.description
            )}
            chartData={chartData?.indigenousFamily || []}
            colors={
                defaultColors.slice(0, chartData?.indigenousFamily?.length) ||
                []
            }
            height={400}
        />
    );
};
